<template>
  <div>
    <div
        class="kc-archive-cats-resources__cat__items normal"
        v-show="!showCarousel"
    >
      <a :href="post.link" class="swiper-slide kc-archive-cats-resources__item" v-for="post in printPost" :key="`kc-archive-cats-resources__item-${ post.id }`">
        <div class="kc-archive-cats-resources__item__img">
          <imageSrcset :imageVar="post.image"></imageSrcset>
        </div>
        <div class="kc-archive-cats-resources__item__content">
          <h3 class="kc-archive-cats-resources__item__content__title">{{ post.title }}</h3>
<!--          <div class="kc-archive-cats-resources__item__content__excerpt" v-html="post.excerpt"></div>-->
          <div class="kc-archive-cats-resources__item__content__read-time" v-if="post.read_time">
            <svg viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z"/></svg>
            <span>{{ post.read_time }} min read</span>
          </div>
        </div>
      </a>
    </div>

    <swiper
        class="kc-archive-cats-resources__cat__items carousel"
        v-if="showCarousel"
        ref="resourcesCarousel"
        :options="swiperOptions"
    >
      <swiper-slide v-for="(slide, i) in carouselSlides" :key="`kc-archive-cats-resources__slide-${ i }`" class="auto-columns">
        <a :href="post.link" class="swiper-slide kc-archive-cats-resources__item" v-for="post in slide" :key="`kc-archive-cats-resources__slide-item-${ post.link }`">
          <div class="kc-archive-cats-resources__item__img">
            <imageSrcset :imageVar="post.image"></imageSrcset>
          </div>
          <div class="kc-archive-cats-resources__item__content">
            <h3 class="kc-archive-cats-resources__item__content__title">{{ post.title }}</h3>
            <div class="kc-archive-cats-resources__item__content__excerpt" v-html="post.excerpt"></div>
          </div>
        </a>
      </swiper-slide>
    </swiper>

  <button v-show="posts.length > curPostPerPage" @click="showMore" class="kc-archive-cats-resources__button btn btn--blue">See all Resources</button>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import imageSrcset from './partials/image-srcset.vue';

export default {
  name: "kc-archive-cats-resources-items",
  props: {
    postPerPage: [Number, String],
    posts: [Object, Array],
  },
  components: {
      Swiper,
      SwiperSlide,
      imageSrcset,
  },
  data() {
    return {
      curPostPerPage: Number(this.postPerPage),
      currentPosts: [],
      postsGroup: 4,
      showCarousel: false,
      swiperOptions: {
          slidersPerView: 1.1,
          spaceBetween: 20,
      }
    }
  },
  methods: {
    showMore() {
      this.curPostPerPage = this.posts.length;
    },
    groupByN(n, data) {
      let result = [];
      for (let i = 0; i < data.length; i += n) result.push(data.slice(i, i + n));
      return result;
    },
    resizeUpdate() {
      if ( window.innerWidth >= 600 && window.innerWidth <= 768 ) {
        this.postsGroup = 4
        this.showCarousel = true;
      }
      else if ( window.innerWidth >= 768 && window.innerWidth <= 1024 ) {
        this.postsGroup = 6;
        this.showCarousel = true;
      }
      else {
        this.showCarousel = false;
      }
    }
  },
  created() {
    this.resizeUpdate();
    window.addEventListener("resize", this.resizeUpdate);
  },
  destroyed() {
    window.addEventListener("resize", this.resizeUpdate);
  },
  computed: {
    printPost() {
     return this.currentPosts = this.posts.slice(0, this.curPostPerPage);
    },
    carouselSlides() {
      return this.groupByN(this.postsGroup, this.posts);
    }
  }
}
</script>

<style lang="scss" scoped>
  .auto-columns {
    display: grid;
    gap: 20px;

    @media only screen and (min-width: 600px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media only screen and (min-width: 768px) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
</style>